import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Form, Button, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import * as XLSX from "xlsx";

import { v4 as uuidv4 } from "uuid";

import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";

ModuleRegistry.registerModules([AllCommunityModule]);



function AjustesInventarioCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_ARTICULOS = import.meta.env.VITE_URL_ARTICULOS;
  const URL_AJUSTES_INVENTARIO = import.meta.env.VITE_URL_AJUSTES_INVENTARIO;
  const URL_ARTICULOS_AJUSTES_INV =
    import.meta.env.VITE_URL_ARTICULOS_AJUSTES_INV;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const AREAS_GENERAL = import.meta.env.VITE_AREAS_GENERAL;
  const URL_INVENTARIOS = import.meta.env.VITE_URL_INVENTARIOS;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;
  
  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [inventarios, setInventarios] = useState([]);
  const [idsArticulos, setIdsArticulos] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [fecha, setFecha] = useState(hoy);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total, setTotal] = useState(0);
  const [articulosUnicos, setArticulosUnicos] = useState([]);
  const [totalCaptura, setTotalCaptura] = useState(1);
  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);
  const [expandedTables, setExpandedTables] = useState({});
  const [urlPhoto, setUrlPhoto] = useState("");
  
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cantidad: 0,
      cantInv: 0,
      idInv: "",
      articulosNombre: "",
      idTalla: "",
      tallaNombre: "",
      idColor: "",
      colorNombre: "",
      colores: [],
      tallas: [],
      idArticuloProporcion: "",
    },
  ]);

  // Ref para el input del scanner (uncontrolled para evitar race conditions con la pistola)
  const scannerInputRef = useRef(null);

  // Manual input for adding individual pieces
  const [manualInput, setManualInput] = useState({
    articulosNombre: "",
    articulos: "",
    idColor: "",
    idTalla: "",
    tallaNombre: "",
    cantInv: 0,
    cantidad: 0,
    colores: [],
    tallas: [],
    idProporcion: "",
  });

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

    // Load tallas
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
        const customeSizeOrder = allTallas.map((t) => t.name);
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    ActualizaTotales();
  }, [inputFields]);

  const saveAjustesInventario = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    
    try {
      // Filter valid articles
      const validArticles = inputFields.filter(
        (a) => a.articulos !== "" && a.cantidad !== 0
      );

      if (validArticles.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "Sin artículos",
          text: "Debe agregar al menos un artículo con cantidad diferente de cero",
        });
        setValidaBoton(true);
        return;
      }

      // Prepare data for the new endpoint
      const adjustmentData = {
        fecha,
        areas: selectedArea,
        observaciones,
        user: user.id,
        total,
        autorizado: "No",
        articulos: validArticles.map(article => ({
          articulos: article.articulos,
          cantidad: parseFloat(article.cantidad),
          idInv: article.idInv,
          idArticuloProporcion: article.idArticuloProporcion,
          idColor: article.idColor,
          idTalla: article.idTalla,
          colorNombre: article.colorNombre,
          tallaNombre: article.tallaNombre,
        }))
      };

      // Call the new createWithArticles endpoint
      const response = await axios.post(
        `${URL_AJUSTES_INVENTARIO}/with-articles`, // New endpoint
        adjustmentData,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      // Success response
      Swal.fire({
        icon: "success",
        title: "¡Éxito!",
        text: `Ajuste creado exitosamente con ${response.data.totalArticles} artículos`,
        timer: 2000,
        showConfirmButton: false,
      });

      setTimeout(() => {
        window.location.reload();
      }, 2000);

    } catch (error) {
      console.error("Error creating adjustment:", error);
      
      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          error.message || 
                          "Error desconocido";

      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
        footer: error.response?.data?.details ? "Ver consola para más detalles" : "",
      });
      
      setValidaBoton(true);
    }
  };

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        cantInv: 0,
        idInv: "",
        articulosNombre: "",
        idTalla: "",
        tallaNombre: "",
        idColor: "",
        colorNombre: "",
        colores: [],
        tallas: [],
        idArticuloProporcion: "",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  // Manual article selection and input
  const handleManualArticuloChange = (selectedArticulo) => {
    let inventario = inventarios.filter(
      (inv) => String(inv.idArticulo) === String(selectedArticulo.idArticulo)
    );

    let tallas = inventario.reduce((acc, curr) => {
      if (!acc.includes(curr.talla)) {
        acc.push(curr.talla);
      }
      return acc;
    }, []);

    let colores = inventario.reduce((acc, curr) => {
      if (!acc.includes(curr.color)) {
        acc.push(curr.color);
      }
      return acc;
    }, []);

    let coloresRed = selectedArticulo.colores.filter((c) =>
      colores.includes(c.name)
    );
    let tallasRed = selectedArticulo.tallas.filter((t) =>
      tallas.includes(t.name)
    );

    if (selectedArticulo) {
      setManualInput({
        articulos: selectedArticulo.idArticulo,
        articulosNombre:
          selectedArticulo.codigo + " " + selectedArticulo.nombre,
        colores: coloresRed,
        tallas: tallasRed,
        idColor: "",
        idTalla: "",
        cantidad: 0,
        idProporcion: "",
      });
      setUrlPhoto(selectedArticulo.urlFoto);
    }
  };

  const handleManualInputChange = (event) => {
    const { name, value } = event.target;

    setManualInput((prev) => {
      const updatedInput = {
        ...prev,
        [name]: value,
      };

      if (name === "idTalla") {
        const selectedTalla = prev.tallas.find((t) => t._id === value);
        updatedInput.tallaNombre = selectedTalla ? selectedTalla.name : "";
      }

      if (name === "cantidad") {
        const selectedColor = manualInput.colores.find(
          (c) => c._id === manualInput.idColor
        );
        const selectedTalla = manualInput.tallas.find(
          (t) => t._id === manualInput.idTalla
        );
        updatedInput.cantidad = parseFloat(value);
        const inventario = inventarios.find(
          (inv) =>
            String(inv.idArticulo) === String(manualInput.articulos) &&
            inv.color === selectedColor?.name &&
            inv.talla === selectedTalla?.name
        );

        if (inventario) {
          updatedInput.idProporcion = inventario.idProporcion;
          updatedInput.cantInv = inventario.cantidad;
        }
      }

      return updatedInput;
    });
  };

  const handleManualAdd = async () => {
    if (
      !manualInput.articulosNombre ||
      !manualInput.idColor ||
      !manualInput.idTalla ||
      !manualInput.cantidad
    ) {
      return;
    }

    const selectedColor = manualInput.colores.find(
      (c) => String(c._id) === String(manualInput.idColor)
    );
    const selectedTalla = manualInput.tallas.find(
      (t) => String(t._id) === String(manualInput.idTalla)
    );

    const inventario = inventarios.find(
      (inv) =>
        String(inv.idArticulo) === String(manualInput.articulos) &&
        inv.color === selectedColor.name &&
        inv.talla === selectedTalla.name
    );

    if (inventario) {
      const available = inputFields.find(
        (i) => i.idArticuloProporcion === inventario.idArticuloProporcion
      );

      if (available) {
        const updatedFields = inputFields.map((field) => {
          if (field.idArticuloProporcion === inventario.idArticuloProporcion) {
            return {
              ...field,
              cantidad: field.cantidad + manualInput.cantidad,
            };
          }
          return field;
        });

        setInputFields(updatedFields);
        resetManualInput();
        return null;
      }

      const newField = {
        id: uuidv4(),
        articulos: manualInput.articulos,
        idInv: inventario._id,
        cantInv: inventario.cantidad,
        articulosNombre: manualInput.articulosNombre,
        idArticuloProporcion: inventario.idArticuloProporcion,
        cantidad: manualInput.cantidad,
        idTalla: manualInput.idTalla,
        tallaNombre: selectedTalla ? selectedTalla.name : "",
        idColor: manualInput.idColor,
        colorNombre: selectedColor ? selectedColor.name : "",
        colores: manualInput.colores,
        tallas: manualInput.tallas,
      };

      setInputFields((prev) => [...prev, newField]);
      resetManualInput();
    }
  };

  const resetManualInput = () => {
    setManualInput((prev) => ({
      ...prev,
      idColor: "",
      articulos: "",
      articulosNombre: "",
      cantidad: 0,
      idTalla: "",
      tallaNombre: "",
      idProporcion: "",
    }));
  };

  // Sanitizar código de barras para comparación consistente
  const sanitizeBarcode = (code) => {
    if (!code) return "";
    return code
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9]/g, "")
      .toUpperCase()
      .trim();
  };

  // Scanner function
  async function buscarArticuloSingular(rawScanValue) {
    try {
      const scanValue = rawScanValue.trim();
      const sanitizedValue = sanitizeBarcode(scanValue);

      inventarios.map((a) => {
        // Buscar por eanProporcion (exacto y sanitizado), idArticuloProporcion o _id
        const eanMatch = a.eanProporcion === scanValue || sanitizeBarcode(a.eanProporcion) === sanitizedValue;
        if (eanMatch || a.idArticuloProporcion === scanValue || a._id === scanValue) {
          const available = inputFields.find(
            (i) => i.idArticuloProporcion === a.idArticuloProporcion
          );

          if (available) {
            const updatedFields = inputFields.map((field) => {
              if (field.idArticuloProporcion === a.idArticuloProporcion) {
                return {
                  ...field,
                  cantidad: field.cantidad + 1,
                };
              }
              return field;
            });

            setInputFields(updatedFields);
            return null;
          }

          const newField = {
            id: uuidv4(),
            articulos: a.idArticulo,
            idInv: a._id,
            cantInv: a.cantidad,
            articulosNombre: a.codigo + " " + a.nombre,
            cantidad: 1,
            idTalla: a.idTalla,
            tallaNombre: a.talla,
            idColor: a.idColor,
            colorNombre: a.color,
            colores: a.colores,
            tallas: a.tallas,
            idArticuloProporcion: a.idArticuloProporcion,
          };
          setUrlPhoto(a.urlFoto);

          setInputFields((prev) => [...prev, newField]);
          resetManualInput();
        }
        return null;
      });
    } catch (error) {
      console.log("error", error);
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
    }
  }

  function BuscaArticulo(id, event) {
    if (
      inventarios.filter((e) => e.idArticulo == event.target.value).length == 1
    ) {
      inventarios.map((a) => {
        if (a.idArticulo == event.target.value) {
          let idArticulo = a.idArticulo;
          let cantInv = parseFloat(a.cantidad);
          let idInv = a._id;
          handleChangeInputArticuloUnico(id, idArticulo, cantInv, idInv);
        }
      });
    } else {
      inventarios.map((a) => {
        if (a.idArticulo == event.target.value) {
          let idArticulo = a.idArticulo;
          handleChangeInputArticulo(id, idArticulo);
        }
      });
    }
  }

  const handleChangeInputArticuloUnico = (id, idArticulo, cantInv, idInv) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.cantInv = parseFloat(cantInv);
        i.idInv = idInv;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputArticulo = (id, idArticulo) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let cant = inputFields
      .filter((c) => c.articulos !== "" && c.cantidad !== 0)
      .map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);
  }

  function jalaAlmacen(e) {
    setSelectedArea(e);

    axios
      .get(`${URL_INVENTARIOS}/traspasos/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allInventarios = res.data;
        setInventarios(allInventarios);

        let result = allInventarios.map((a) => a.idArticulo);
        setIdsArticulos(result);

        let unicos = allInventarios.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idArticulo === value.idArticulo)
        );
        setArticulosUnicos(unicos);
      })
      .catch((err) => {
        console.log(err);
      });

    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        cantInv: 0,
        idInv: "",
        articulosNombre: "",
        idTalla: "",
        tallaNombre: "",
        idColor: "",
        colorNombre: "",
        colores: [],
        tallas: [],
        idArticuloProporcion: "",
      },
    ]);
  }

  function BuscaCodigo(id, event) {
    if (event.target.value.length >= 24) {
      if (idsArticulos.includes(event.target.value)) {
        inventarios.map((a) => {
          if (a.idArticulo == event.target.value) {
            let idArticulo = a.idArticulo;
            handleChangeInputArticulo(id, idArticulo);
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El modelo no aparece en tu inventario",
          showConfirmButton: false,
        });
        const newInputFields = inputFields.map((i) => {
          if (id === i.id) {
            i.articulos = "";
          }
          return i;
        });
        setInputFields(newInputFields);
      }
    } else {
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.articulos = event.target.value;
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  }

  // Options for autocomplete
  const options2 = articulosUnicos.map((option) => {
    const junta = option.codigo;
    const firstLetter = option.codigo[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.ajustesInventario ? (
        <div className="card container col-12">
          <h3 align="center">Nuevo Ajuste De Inventario</h3>
          <Form onSubmit={saveAjustesInventario}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  disabled
                />
              </Col>

              <Col md={3}>
                <Label className="mr-sm-2">Almacen</Label>
                {user.areas == AREAS_GENERAL ? (
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={selectedArea}
                    required
                    onChange={(e) => {
                      jalaAlmacen(e.target.value);
                    }}
                  >
                    <option value="0">Almacen</option>
                    {areas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (a._id != AREAS_GENERAL) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                ) : (
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={selectedArea}
                    required
                    onChange={(e) => {
                      jalaAlmacen(e.target.value);
                    }}
                  >
                    <option value="0">Almacen</option>
                    {areas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (user.areas == a._id) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                )}
              </Col>
              <Col md={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <h4 id="logoutBoton">TOTALES {total} pzas.</h4>
              </Col>
            </Row>

            {/* Add New Articles Section */}
            <div style={{ position: "relative" }}>
              <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Escanea el QR</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Selecciona</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Articulo</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Color</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Talla</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Cantidad</Label>
                </Col>
              </Row>

              <Row>
                <Col md={2}>
                  <Input
                    name="idProporcion"
                    type="text"
                    innerRef={scannerInputRef}
                    autoComplete="off"
                    placeholder="Escanear código"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        e.stopPropagation();
                        const value = scannerInputRef.current?.value || "";
                        if (value.trim().length >= 2) {
                          buscarArticuloSingular(value);
                        }
                        if (scannerInputRef.current) {
                          scannerInputRef.current.value = "";
                        }
                      }
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Autocomplete
                    size="small"
                    value={manualInput?.articulosNombre || ""}
                    onChange={(event, selectedArticulo) => {
                      handleManualArticuloChange(selectedArticulo);
                    }}
                    options={options2.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option?.junta || ""}                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(props, option) => (
  <li {...props} key={option._id}>
    {option.codigo} {option.nombre}
  </li>
)}
                  />
                </Col>
                <Col md={2}>
                  <Input
                    type="text"
                    value={manualInput?.articulosNombre || ""}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    name="idColor"
                    type="select"
                    value={manualInput?.idColor || ""}
                    onChange={handleManualInputChange}
                  >
                    <option value="">Selecciona Color</option>
                    {manualInput?.colores?.map((color) => (
                      <option key={color._id} value={color._id}>
                        {color.name}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col md={1}>
                  <Input
                    name="idTalla"
                    type="select"
                    value={manualInput.idTalla || ""}
                    onChange={handleManualInputChange}
                  >
                    <option value="">Selecciona Talla</option>
                    {manualInput.tallas &&
                      manualInput.tallas.map((talla) => (
                        <option key={talla._id} value={talla._id}>
                          {talla.name}
                        </option>
                      ))}
                  </Input>
                </Col>
                <Col md={1}>
                  <Input
                    name="cantidad"
                    type="number"
                    step="any"
                    placeholder="Cantidad"
                    disabled={!manualInput?.idColor || !manualInput?.idTalla}
                    value={manualInput?.cantidad || 0}
                    onChange={handleManualInputChange}
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="success"
                    onClick={handleManualAdd}
                    disabled={
                      !manualInput?.articulosNombre ||
                      !manualInput?.idColor ||
                      !manualInput?.idTalla ||
                      !manualInput?.cantidad
                    }
                    tabIndex="-1"
                  >
                    Agregar
                  </Button>
                </Col>
              </Row>

              {/* Photo preview */}
              {urlPhoto && (
                <div
                  style={{
                    position: "absolute",
                    right: "5%",
                    top: "-40px",
                    width: "150px",
                    height: "auto",
                    maxHeight: "80px",
                    zIndex: 2,
                  }}
                >
                  <img
                    src={urlPhoto}
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      background: "#fff",
                    }}
                  />
                </div>
              )}
            </div>

            <br />
            <hr />

            {/* Advanced Articles Grid */}
            <div>
              {Object.entries(
                inputFields
                  .filter((field) => field.articulosNombre && field.articulos)
                  .reduce((acc, field) => {
                    const key = `${field.articulosNombre}`;
                    if (!acc[key]) {
                      acc[key] = {
                        articuloInfo: {
                          articulosNombre: field.articulosNombre,
                          articulos: field.articulos,
                          availableTallas: Array.from(
                            new Set(
                              inputFields
                                .filter(
                                  (f) =>
                                    f.articulosNombre ===
                                    field.articulosNombre
                                )
                                .map((f) => f.tallaNombre)
                                .filter(Boolean)
                                .sort((a, b) => {
                                  return (
                                    customSizeOrder.indexOf(a) -
                                    customSizeOrder.indexOf(b)
                                  );
                                })
                            )
                          ),
                        },
                        colorGroups: [],
                      };
                    }

                    const existingColorIndex = acc[key].colorGroups.findIndex(
                      (item) => item.idColor === field.idColor
                    );

                    if (existingColorIndex === -1) {
                      acc[key].colorGroups.push({
                        id: field.id,
                        articulos: field.articulos,
                        articulosNombre: field.articulosNombre,
                        idColor: field.idColor,
                        colorNombre: field.colorNombre,
                        colores: field.colores,
                        quantities: {
                          [field.tallaNombre]: {
                            cantidad: field.cantidad,
                            id: field.id,
                            cantInv: field.cantInv,
                            cantidadFinal: field.cantInv + field.cantidad,
                          },
                        },
                      });
                    } else {
                      acc[key].colorGroups[existingColorIndex].quantities[
                        field.tallaNombre
                      ] = {
                        cantidad: field.cantidad,
                        id: field.id,
                        cantInv: field.cantInv,
                        cantidadFinal: field.cantInv + field.cantidad,
                      };
                    }
                    return acc;
                  }, {})
              ).map(([articuloNombre, { articuloInfo, colorGroups }]) => {
                const articleTotals = colorGroups.reduce(
                  (totals, group) => {
                    const quantitySum = Object.values(group.quantities).reduce(
                      (sum, q) => sum + (parseFloat(q.cantidad) || 0),
                      0
                    );

                    return {
                      items: totals.items + quantitySum,
                    };
                  },
                  { items: 0 }
                );

                return (
                  <div key={articuloNombre} className="mb-8">
                    <div className="d-flex align-items-center border-t-2 border-gray-200 pt-2 pb-2 bg-gray-50">
                      <div className="d-flex align-items-center">
                        <Button
                          size="sm"
                          className="btn mr-3"
                          color="info"
                          onClick={() =>
                            setExpandedTables((prev) => ({
                              ...prev,
                              [articuloNombre]: !prev[articuloNombre],
                            }))
                          }
                        >
                          <i
                            className={`fas fa-chevron-${
                              expandedTables[articuloNombre] ? "up" : "down"
                            }`}
                          ></i>
                        </Button>
                        <h4 className="negrita mb-0 mr-4">
                          {articuloNombre}
                        </h4>
                      </div>
                      {!expandedTables[articuloNombre] && (
                        <div className="d-flex align-items-center">
                          <span
                            className="mr-4 text-dark"
                            style={{ fontSize: "18px" }}
                          >
                            <strong style={{ fontSize: "18px" }}>
                              Ajuste Total:
                            </strong>{" "}
                            {articleTotals.items} pzas
                          </span>
                        </div>
                      )}
                    </div>

                    {expandedTables[articuloNombre] &&
                      (() => {
                        const rowData = colorGroups.map((group) => {
                          const tallaQuantities = {};
                          const tallaInventories = {};
                          const tallaFinals = {};
                          
                          articuloInfo.availableTallas.forEach((talla) => {
                            tallaQuantities[`talla_${talla}`] =
                              group.quantities[talla]?.cantidad || 0;
                            tallaQuantities[`tallaId_${talla}`] =
                              group.quantities[talla]?.id || group.id;
                            tallaInventories[`inv_${talla}`] =
                              group.quantities[talla]?.cantInv || 0;
                            tallaFinals[`final_${talla}`] =
                              group.quantities[talla]?.cantidadFinal || 0;
                          });

                          return {
                            ...group,
                            ...tallaQuantities,
                            ...tallaInventories,
                            ...tallaFinals,
                          };
                        });

                        const columnDefs = [
                          {
                            headerName: "Artículo",
                            field: "articulosNombre",
                            minWidth: 120,
                            autoHeight: true,
                            wrapText: true,
                            editable: false,
                            cellStyle: {
                              overflow: "visible",
                              whiteSpace: "normal",
                            },
                          },
                          {
                            headerName: "Color",
                            field: "colorNombre",
                            minWidth: 100,
                            autoHeight: true,
                            wrapText: true,
                            editable: false,
                            cellStyle: {
                              overflow: "visible",
                              whiteSpace: "normal",
                            },
                          },
                        ];

                        // Add columns for each talla (3 columns per talla: Inventario, Ajuste, Final)
                        articuloInfo.availableTallas.forEach((talla) => {
                          // Inventario column
                          columnDefs.push({
                            headerName: `${talla} Inv`,
                            field: `inv_${talla}`,
                            minWidth: 60,
                            editable: false,
                            type: "numericColumn",
                            valueFormatter: (params) => params.value || 0,
                            cellStyle: { 
                              textAlign: "center",
                              backgroundColor: "#f0f8ff"
                            },
                          });

                          // Ajuste column (editable)
                          columnDefs.push({
                            headerName: `${talla} Ajuste`,
                            field: `talla_${talla}`,
                            minWidth: 70,
                            editable: true,
                            type: "numericColumn",
                            valueFormatter: (params) => params.value || 0,
                            cellStyle: { textAlign: "center" },
                            onCellValueChanged: (params) => {
                              const id = params.data[`tallaId_${talla}`];
                              const event = {
                                target: {
                                  name: "cantidad",
                                  value: params.newValue,
                                },
                              };
                              handleChangeInputCantidad(id, event);
                            },
                          });

                          // Final column (calculated)
                          columnDefs.push({
                            headerName: `${talla} Final`,
                            field: `final_${talla}`,
                            minWidth: 60,
                            editable: false,
                            type: "numericColumn",
                            valueFormatter: (params) => {
                              const inv = params.data[`inv_${talla}`] || 0;
                              const ajuste = params.data[`talla_${talla}`] || 0;
                              return inv + ajuste;
                            },
                            cellStyle: { 
                              textAlign: "center",
                              backgroundColor: "#f0fff0",
                              fontWeight: "bold"
                            },
                          });
                        });

                        columnDefs.push({
                          headerName: "",
                          field: "actions",
                          minWidth: 60,
                          cellRenderer: (params) => {
                            return (
                              <Button
                                size="sm"
                                className="btn"
                                color="danger"
                                onClick={() =>
                                  handleRemoveFields(params.data.id)
                                }
                                tabIndex="-1"
                              >
                                <i className="fas fa-minus"></i>
                              </Button>
                            );
                          },
                        });

                        const defaultColDef = {
                          suppressMovable: true,
                          suppressMenu: true,
                          sortable: true,
                          resizable: true,
                          filter: true,
                          autoHeaderHeight: true,
                        };

                        const onGridReady = (params) => {
                          const api = params.api;
                          setTimeout(() => {
                            api.sizeColumnsToFit();
                          }, 100);

                          const targetNode =
                            document.querySelector(".ag-theme-alpine");
                          if (targetNode) {
                            const observer = new MutationObserver(() => {
                              setTimeout(() => {
                                api.sizeColumnsToFit();
                              }, 100);
                            });

                            observer.observe(targetNode, {
                              childList: true,
                              subtree: true,
                              attributes: true,
                              characterData: true,
                            });
                          }
                        };

                        const onCellValueChanged = () => {
                          const gridDiv =
                            document.querySelector(".ag-theme-alpine");
                          const gridApi =
                            gridDiv?.querySelector(
                              ".ag-root-wrapper"
                            )?.__agGridApi;
                          if (gridApi) {
                            setTimeout(() => {
                              gridApi.sizeColumnsToFit();
                            }, 100);
                          }
                        };

                        return (
                          <div
                            className="ag-theme-alpine"
                            style={{ width: "auto", maxWidth: "100%" }}
                          >
                            <AgGridReact
                              columnDefs={columnDefs}
                              rowData={rowData}
                              defaultColDef={defaultColDef}
                              domLayout="autoHeight"
                              animateRows={true}
                              suppressRowClickSelection={true}
                              getRowId={(params) =>
                                `${params.data.id}-${params.data.idColor}`
                              }
                              headerHeight={32}
                              rowHeight={38}
                              stopEditingWhenCellsLoseFocus={true}
                              onGridReady={onGridReady}
                              onCellValueChanged={onCellValueChanged}
                              onRowDataUpdated={onCellValueChanged}
                              onColumnResized={onCellValueChanged}
                              onGridSizeChanged={onCellValueChanged}
                            />
                          </div>
                        );
                      })()}
                  </div>
                );
              })}
            </div>

          

            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">TOTALES {total} pzas.</h4>
              </Col>
            </Row>

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoAjustesInventario"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default AjustesInventarioCreate;